// DataLayer utilities — push GA4/GTM "generate_lead" event after form submission.
// Include PII in chiaro per Enhanced Conversions (l'hashing è fatto lato GTM/sGTM).
//
// Esempio di chiamata:
//   pushLeadToDataLayer({
//     form_name: 'preventivo_wizard',
//     name: 'Mario Rossi',
//     email: 'mario@rossi.ch',
//     phone: '+41 79 123 45 67',
//     company: 'Acme SA',
//     course: 'BLS-AED SRC',
//     participants: 10,
//     message: 'Note libere',
//     value: 0,
//   });

function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? m[2] : null;
}

export function pushLeadToDataLayer(data) {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];

    const nameParts = (data.name || "").trim().split(/\s+/);

    window.dataLayer.push({
        event: "generate_lead",

        // Identificazione form
        form_name: data.form_name || "form_generic",
        form_location: window.location.pathname,
        page_url: window.location.href,
        page_title: document.title,

        currency: "CHF",
        value: data.value || 0,

        // Dettagli specifici del lead
        lead_details: {
            course_interest: data.course || "",
            participants_count: data.participants || null,
            company: data.company || "",
            message_provided: !!data.message,
        },

        // PII per Enhanced Conversions / Meta CAPI (hashing lato GTM/sGTM)
        user_data: {
            email_address: (data.email || "").trim().toLowerCase(),
            phone_number: (data.phone || "").replace(/[\s\-().]/g, ""),
            address: {
                first_name: (nameParts[0] || "").toLowerCase(),
                last_name: (nameParts.slice(1).join(" ") || "").toLowerCase(),
            },
        },

        // Cookie per correlazione server-side
        ga_client_id: getCookie("_ga"),
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
    });
}
